//修改新设备保存列表
export const DEVICEMANAGEMENT_SREACH_DEVICE_INFO='DEVICEMANAGEMENT/SREACH/DEVICE/INFO/DEVICEMANAGEMENT_SREACH_DEVICE_INFO';

//设置采集器状态可点击或者不可点击
export const DEVICEMANAGEMENT_COLLECTOR_DISABLED_STATUS='DEVICEMANAGEMENT/COLLECTOR/DISABLED/STATUS/DEVICEMANAGEMENT_DISABLED_STATUS';

//设置添加设备按钮可点击或者不可点击
export const DEVICEMANAGEMENT_BUTTON_DISABLED_STATUS='DEVICEMANAGEMENT/BUTTON/DISABLED/STATUS/DEVICEMANAGEMENT_BUTTON_DISABLED_STATUS';
